import {
  CTABanner as CTABannerUI,
  CTALink,
  CTABannerProps as CTABannerPropsUI
} from "@business-finland/wif-ui-lib/dist/CTABanner";
import React from "react";

import useImageDataHandler from "../../../hooks/useImageDataHandler";
import { resolveLinkSwitchableField } from "../../../util/magnolia";
import { LinkSwitchableField } from "../../../types/wif-next";

export type CTABannerType = {
  link?: LinkSwitchableField;
  btnText: string;
} & (
  | {
      field: "buttonOnly";
    }
  | {
      field: "default";
      headline: string;
      bodyText?: string;
    }
  | {
      field: "imageBackground";
      headline: string;
      bodyText?: string;
      image: Wif.Mgnl.Image;
      imageCredit?: string;
      imageAlt?: string;
    }
);

export type CTABannerProps = {
  ctaBannerType: CTABannerType;
};

const transformLink = (ctaBannerType: CTABannerType): CTALink => {
  const resolvedLink = resolveLinkSwitchableField(ctaBannerType.link, false);
  return {
    title: ctaBannerType.btnText,
    href: resolvedLink.linkHref,
    isExternalLink: resolvedLink.isExternalLink,
  };
};

export function CTABanner({
  ctaBannerType,
}: CTABannerProps): React.JSX.Element {
  const imageDataHandler = useImageDataHandler();

  const props: CTABannerPropsUI = {
    link: transformLink(ctaBannerType),
    btnText: ctaBannerType.btnText,
  };

  if (
    ctaBannerType.field === "default" ||
    ctaBannerType.field === "imageBackground"
  ) {
    props.headline = ctaBannerType.headline;
    props.body = ctaBannerType.bodyText;
  }

  if (ctaBannerType.field === "imageBackground") {
    const imageData = imageDataHandler(ctaBannerType.image);

    props.image = {
      credits: ctaBannerType.imageCredit || ctaBannerType.image.metadata.rights,
      altText:
        ctaBannerType.imageAlt || ctaBannerType.image.metadata.title || "",
      ...imageData,
    };
  }

  return <CTABannerUI {...props} />;
}
